import * as fromDatatype from "../datatype-library/index";

export interface bl_fi_cashbook_txn_stmt_recon_link_RowInterface {
	guid: fromDatatype.GuidDataFieldInterface;
	cash_stmt_hdr_guid: fromDatatype.GuidDataFieldInterface;
	cash_stmt_line_guid: fromDatatype.GuidDataFieldInterface;
	cashbook_txn_line_guid: fromDatatype.GuidDataFieldInterface;
	bank_recon_hdr_guid: fromDatatype.GuidDataFieldInterface;
	logic: fromDatatype.TextDatatypeInterface;
	option: fromDatatype.TextDatatypeInterface;
	descr: fromDatatype.TextDatatypeInterface;
	remarks: fromDatatype.TextDatatypeInterface;
	amount_contra: fromDatatype.NumericDatatypeInterface;
	amount_signum: fromDatatype.NumericDatatypeInterface;
	property_json: fromDatatype.JsonDatatypeInterface;
	created_date: fromDatatype.TimestampTzDatatypeInterface;
	updated_date: fromDatatype.TimestampTzDatatypeInterface;
	created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
	updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
	status: fromDatatype.TextDatatypeInterface;
	revision: fromDatatype.GuidDataFieldInterface;
	vrsn: fromDatatype.TextDatatypeInterface;
	txn_type: fromDatatype.TextDatatypeInterface;
}

export class bl_fi_cashbook_txn_stmt_recon_link_RowClass implements bl_fi_cashbook_txn_stmt_recon_link_RowInterface {
	guid: fromDatatype.GuidDataFieldInterface;
	cash_stmt_hdr_guid: fromDatatype.GuidDataFieldInterface;
	cash_stmt_line_guid: fromDatatype.GuidDataFieldInterface;
	cashbook_txn_line_guid: fromDatatype.GuidDataFieldInterface;
	bank_recon_hdr_guid: fromDatatype.GuidDataFieldInterface;
	logic: fromDatatype.TextDatatypeInterface;
	option: fromDatatype.TextDatatypeInterface;
	descr: fromDatatype.TextDatatypeInterface;
	remarks: fromDatatype.TextDatatypeInterface;
	amount_contra: fromDatatype.NumericDatatypeInterface;
	amount_signum: fromDatatype.NumericDatatypeInterface;
	property_json: fromDatatype.JsonDatatypeInterface;
	created_date: fromDatatype.TimestampTzDatatypeInterface;
	updated_date: fromDatatype.TimestampTzDatatypeInterface;
	created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
	updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
	status: fromDatatype.TextDatatypeInterface;
	revision: fromDatatype.GuidDataFieldInterface;
	vrsn: fromDatatype.TextDatatypeInterface;
	txn_type: fromDatatype.TextDatatypeInterface;
}